// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Event Handlers
import { CallbackBackHandlers } from 'handlers/callback-back.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Types
import {
  CallbackBackHookType,
  CallbackBackMethodsHandlersType,
} from 'handlers/types/callback-back.handlers.type';

const useCallbackBackHook = (props?: CallbackBackHookType): CallbackBackMethodsHandlersType => {
  const { callbackUrl, loanId, setCurrentState } = useAppContextConsumerHook();

  const { handleSendCustomActionEvent } = LogHandlers();

  return CallbackBackHandlers({
    callbackUrl,
    handleSendCustomActionEvent,
    loanId,
    resetBoundary: props?.resetBoundary,
    setCurrentState,
  });
};

export { useCallbackBackHook };
